import { CrudList } from '../shared/CrudPage';
import { orderReturnService, enumLabel } from '@kss/api';
import type { OrderReturn, OrderReturnCreate, OrderReturnFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';
import { NameCell } from '../../hooks/useNameMaps';

export default function AllOrderReturns() {
  return (
    <CrudList<OrderReturn, OrderReturnCreate, OrderReturnFilter>
      title="All returns" newLabel="New return" service={orderReturnService}
      idKey="orderReturnId" labelKey="returnNumber" basePath="/panel/order-returns"
      // Newest return at the top — returnNumber embeds a date prefix that
      // sorts wrong chronologically ascending. Ref: ORDER_WORKFLOW_AUDIT #6.
      initialSortStatus={{ columnAccessor: 'returnDate', direction: 'desc' }}
      columns={[
        { accessor: 'returnNumber', title: 'Return #', sortable: true, filterable: true, width: 140 },
        { accessor: 'returnDate', title: 'Date', sortable: true, render: (r) => r.returnDate ? new Date(r.returnDate).toLocaleDateString() : '—' },
        { accessor: 'orderType', title: 'For', render: (r) => enumLabel('OrderReturnType', typeof r.orderType === 'number' ? r.orderType : Number(r.orderType)) },
        { accessor: 'orderId', title: 'Order', render: (r) => <NameCell kind="salesOrder" id={r.orderId ?? r.salesOrderId} /> },
        { accessor: 'refundAmount', title: 'Refund (₹)', sortable: true, textAlign: 'right', render: (r) => Number(r.refundAmount ?? 0).toLocaleString('en-IN') },
        { accessor: 'status', title: 'Status', sortable: true, render: (r) => <StatusBadge status={String(r.status ?? '—')} /> },
      ]}
    />
  );
}
